// extracted by mini-css-extract-plugin
export var infoItem = "_jy-1";
export var title = "_jy-0";